<template>
  <div>
    <div class="text-center pt-10">
      <div>
        <span style="position: relative">
          <v-icon color="primary" size="140">mdi-circle-outline</v-icon>
          <v-icon
            style="
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
            "
            color="#F41608"
            size="90"
            >mdi-check</v-icon
          >
        </span>
      </div>
      <div class="primary--text" style="font-size: 40px">ยืนยันสำเร็จ</div>
      <div class="px-7 pt-5">
        <v-btn
          @click="next"
          style="font-size: 22px"
          class="text-capitalize"
          color="primary"
          dark
          block
          >สะสมแต้ม</v-btn
        >
        <v-btn
          @click="$liff.closeWindow()"
          style="font-size: 22px"
          class="text-capitalize mt-5"
          color="grey"
          dark
          block
          >ปิด</v-btn
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    async next() {
      await this.$store.dispatch("sendMessage", "สะสมแต้ม");
      this.query.view = "PointManager";
      this.$store.state.redirectview = this.query.view;
    },
  },
};
</script>

<style lang="scss" scoped></style>
